import { render, staticRenderFns } from "./brandProtocol.vue?vue&type=template&id=1293c7ea&scoped=true"
import script from "./brandProtocol.vue?vue&type=script&lang=js"
export * from "./brandProtocol.vue?vue&type=script&lang=js"
import style0 from "./brandProtocol.vue?vue&type=style&index=0&id=1293c7ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1293c7ea",
  null
  
)

export default component.exports